import { Tooltip2 } from '@blueprintjs/popover2'
import styled from 'styled-components'

export const Tooltip = styled(Tooltip2).attrs(() => ({
  popoverClassName: 'tooltip',
}))``
